<template>
    <div class="col-4 pl-2" id="w-4">
        <div class="card-dashboard card-his" v-if="$detect == 'web'">
            <div class="title-card p-10px">
                Lịch up tự động trong 30 ngày tiếp theo
            </div>
            <p class="mb-0 text-primary px-10px py-1 border-bottom" role="button"
                v-if="showDetail && product.length > 1" @click="showDetail = false">Danh sách tin</p>
            <div :class="{
                    'body-card-history': true,
                    'no-history': data.length == 0 && showDetail,
                    'one-history': product.length == 1 && showDetail
                }">
                <div v-if="product.length > 1 && !showDetail">
                    <div class="history-rv d-flex p-10px" role="button"
                        v-for="(item, index) in product" :key="index"
                        @click="callData(item.pro_id)">
                        <div class="stt">
                            <p class="mb-0 fw-600">#{{item.pro_id}}</p>
                        </div>
                        <div class="name">
                            <p class="mb-0 text text-primary">{{item.pro_name}}</p>
                        </div>
                        <div class="detail text-right">
                            <button class="btn-detail"><i class="icon ion-md-today"></i></button>
                        </div>
                    </div>
                </div>
                <div v-if="(showDetail && !loading && data.length > 0) || product.length == 1">
                    <div class="d-flex list-history p-10px" v-for="(item, index) in data" :key="index">
                        <div class="stt fw-600">{{item.day_week}}</div>
                        <div class="date-time">{{item.schedule}}</div>
                        <div :class="{
                            'status': true,
                            'text-success fw-600': item.status == 0,
                            'text-danger': item.status == 1,
                        }">
                            {{ item.status == 0 ? 'Đang chờ' : 'Đã Up' }}
                        </div>
                        <div class="edit text-right" v-if="item.status == 0">
                            <button class="btn-edit" @click="updateUp(item, index)"
                                ><i class="icon ion-md-create"></i></button>
                        </div>
                    </div>
                    <div :class="{
                            'load-more bg-white text-center': true,
                            'text-uppercase': !loadingPage
                        }" role="button"
                        v-if="next_page" @click="callData(idActive, next_page)">
                        {{loadingPage ? 'Đang lấy dữu liệu' : 'xem thêm'}}
                    </div>
                </div>
                <div class="text-no-history text-center mt-5 fs-20px" v-if="!loading && data.length == 0 && showDetail">
                    Chưa có tin up tự động
                </div>
                <div class="text-no-history text-center mt-5 fs-20px" v-if="loading">
                    Đang tải dữu liệu
                </div>
            </div>
        </div>
        <ldc-dialog
            v-else
            title="Lịch Up tự động"
            colorTitle="#fff"
            :clickoutside="true"
            width="50%"
            :fullscreen="$detect == 'mobile'"
            class= "popup-history"
            :visible.sync="visible">
            <div :class="{
                    'history': true,
                    'show-list-news': !showDetail
                }">
                <p class="mb-0 text-primary p-10px border-bottom back-to-list" role="button"
                    v-if="showDetail && product.length > 1" @click="showDetail = false">Danh sách sản phẩm</p>
                <div :class="{
                        'body-card-history': true,
                        'no-history': data.length == 0 && showDetail,
                        'one-history': product.length == 1 && showDetail
                    }">
                    <div v-if="product.length > 1 && !showDetail">
                        <div class="history-rv d-flex p-10px" v-for="(item, index) in product" :key="index" role="button"
                            @click="callData(item.pro_id)">
                            <div class="stt">
                                <p class="mb-0 fw-600">#{{item.pro_id}}</p>
                            </div>
                            <div class="name">
                                <p class="mb-0 text text-primary">{{item.pro_name}}</p>
                            </div>
                            <div class="detail text-right">
                                <button class="btn-detail"><i class="icon ion-md-today"></i></button>
                            </div>
                        </div>
                    </div>
                    <div v-if="(showDetail && !loading && data.length > 0) || product.length == 1">
                        <div class="d-flex list-history p-10px" v-for="(item, index) in data" :key="index">
                            <div class="stt fw-600">{{item.day_week}}</div>
                            <div class="date-time">{{item.schedule}}</div>
                            <div :class="{
                                    'status': true,
                                    'text-success fw-600': item.status == 0,
                                    'text-danger': item.status == 1,
                                }">
                                {{ item.status == 0 ? 'Đang chờ' : 'Đã Up' }}
                            </div>
                            <div class="edit text-right" v-if="item.status == 0">
                                <button class="btn-edit"
                                    @click="updateUp(item, index)">
                                    <i class="icon ion-md-create"></i>
                                </button>
                            </div>
                        </div>
                        <div :class="{
                                'load-more bg-white text-center': true,
                                'text-uppercase': !loadingPage
                            }" role="button"
                            v-if="next_page" @click="callData(idActive, next_page)">
                            {{loadingPage ? 'Đang lấy dữu liệu' : 'xem thêm'}}
                        </div>
                    </div>
                    <div class="text-no-history text-center mt-5 fs-20px" v-if="!loading && data.length == 0 && showDetail">
                        Chưa có tin up tự động
                    </div>
                    <div class="text-no-history text-center mt-5 fs-20px" v-if="loading">
                        Đang tải dữu liệu
                    </div>
                </div>
            </div>
        </ldc-dialog>
        <ldc-model-mobile
            titileCancel="Hủy"
            :showCancel="!$isAndroid"
            :showTitle="true"
            title="Thay đổi thời gian up"
            :customButton="true"
            :visible.sync="changeTime"
            v-if="$detect == 'mobile'">
            <div slot="content-model"
            :class="{
                'time-android' : $isAndroid,
                'time-ios' : !$isAndroid,
            }">
                <div class="content-change-time">
                    <div class="d-flex justify-content-between">
                        <div class="fw-600">
                            Ngày:
                        </div>
                        <div>
                            <input type="date" class="date-change" v-model="date"
                                :min="dayNow"/>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="fw-600">
                            Giờ:
                        </div>
                        <div>
                            <ldc-time placeholder="HH:mm"
                                :showSeconds="false"
                                :jumpMinutes="5"
                                titleMobile="Thời gian"
                                v-model="timeUpdate"
                                class="time-change"/>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="custom-buttom"
                :class="{
                    'time-btn-android': $isAndroid,
                    'time-btn-ios': !$isAndroid,
                }">
                <div :class="{
                    'btn-confirm-android': $isAndroid,
                    'btn-confirm-ios mb-10px': !$isAndroid
                    }">
                    <button class="btn btn-light radius-ios text-uppercase mr-10px fs-14px btn-cancel"
                        close-model-mobile v-if="$isAndroid">Huỷ</button>
                    <button class="btn btn-primary radius-ios text-uppercase fs-14px btn-apply"
                        close-model-mobile @click="submit()">cập nhật</button>
                </div>
            </div>
        </ldc-model-mobile>
        <ldc-dialog
            v-else
            title="Thay đổi thời gian"
            :clickoutside="true"
            width="30%"
            :fullscreen="$detect == 'mobile'"
            class= "modal-time-pc"
            :visible.sync="changeTime">
            <div class="content-modal py-3 px-10px">
                <div class="d-flex justify-content-between">
                    <div class="fw-600">
                        Ngày:
                    </div>
                    <div>
                        <input type="date" class="date-change" v-model="date" :min="dayNow"/>
                    </div>
                </div>
                <div class="d-flex justify-content-between mt-3">
                    <div class="fw-600">
                        Giờ:
                    </div>
                    <div>
                        <ldc-time placeholder="HH:mm"
                            :showSeconds="false"
                            :jumpMinutes="5"
                            titleMobile="Thời gian"
                            v-model="timeUpdate"
                            class="time-change"/>
                    </div>
                </div>
            </div>
            <div class="footer-modal text-center">
                <button class="btn btn-confirm my-10px mx-auto" @click="submit()">Xác nhận</button>
            </div>
        </ldc-dialog>
    </div>
</template>
<script>
import { getMinutes, getDayTextInWeek } from '@/config/function';
export default {
    props: ['product', 'dialog'],
    data() {
        return {
            showDetail: false,
            data: [],
            next_page: 0,
            loading: false,
            idActive: '',
            visible: false,
            widthMore: '',
            loadingPage: false,
            changeTime: false,
            date: '',
            timeUpdate: '',
            dayNow: '',
            id: 0,
            indexUpdate: '',
        }
    },
    watch: {
        product(val){
            if(val.length == 1){
                this.callData(val[0].pro_id);
            }else if(val.length > 1){
                this.showDetail = false;
            }
        },
        dialog(val){
            this.visible = val;
        },
        visible(val){
            this.$emit('update:dialog', val);
        }
    },
    created() {
        this.$eventBus.$on('call-history-auto-up', (data) => {
            if(this.idActive === data){
                this.loadingPage = true;
                apiGet(`/v2/profile/products/list_auto_up`, {
                    page: this.next_page > 1 ? this.next_page - 1 : 1,
                    id : data
                }).then(res => {
                    let data = res.data;
                    let check = this.data.length % 20;
                    if(check !== 0 || check === 0 && this.data.length === 0){
                        data.data.map((item, index) => {
                            if(index >= check) this.data.push(item);
                        });
                    }
                    this.next_page = data.next_page;
                    this.loadingPage = false;
                    this.sortHistory();
                });
            }
        })
        if(this.product.length == 1){
            this.callData(this.product[0].pro_id);
        }
    },
    methods: {
        sortHistory(){
            this.data.sort((a, b) => {
                return a.schedule_time - b.schedule_time;
            });
        },
        callData(id, page = 1){
            this.showDetail = true;
            if(this.idActive !== id){
                page = 1;
                this.data = [];
            }
            this.idActive = id;
            if(page == 1){
                this.loading = true;
            }else{
                this.loadingPage = true;
            }
            
            apiGet(`/v2/profile/products/list_auto_up`, {
                page: page,
                id : id
            }).then(res => {
                let data = res.data;
                this.data = data[id].data;


                // if(data.length > 1){

                // }else{
                //     data[id].data.map(item => {
                //         this.data.push(item)
                //     })
                // }
                // data[id].data.map(item => {
                //     this.data.push(item)
                // })
                this.next_page = data.next_page;
                this.loading = false;
                this.loadingPage = false;
                this.sortHistory();
            }).catch(() => {
                this.loading = false;
                this.loadingPage = false;
            });
        },
        updateUp(item, index){
            let day = new Date();
            let dayNow = day.getDate() < 10 ? '0'+day.getDate() : day.getDate();
            let m = day.getMonth() + 1 < 10 ? '0'+(day.getMonth()+1) : day.getMonth() + 1;
            this.dayNow = day.getFullYear() + '-' + m + '-' + dayNow;
            this.changeTime = true;
            let date = item.schedule.split(' ');
            this.timeUpdate = date[1];
            date = date[0].split('/');
            this.date = date[2] + '-' + date[1] + '-' + date[0];
            this.date = checkDateInput(this.date);
            this.id = item.id;
            this.indexUpdate = index;
        },
        submit(){
            let date = checkDateInput(this.date);
            if(!date){
                this.$message({
                    message: 'Vui lòng chọn ngày',
                    type: 'warning',
                    center: true,
                })
            }else{
                date = date.split('-');
                let datePut = date[2] + '-' + date[1] + '-' + date[0];
                let data = {
                    id: this.id,
                    pro_id: this.idActive,
                    date: datePut,
                    time: getMinutes(this.timeUpdate),
                }
                apiPut('/v2/profile/products/update_time_auto_up', data).then(res => {
                    if(res.success == 1){
                        this.$message({
                            message: 'Cập nhật thành công',
                            type: 'success',
                            center: true,
                        });
                        this.data[this.indexUpdate].schedule = datePut.split('-').join('/') + ' ' + this.timeUpdate;
                        this.data[this.indexUpdate].day_week = getDayTextInWeek(new Date(date).getDay());
                        this.data[this.indexUpdate].schedule_time = res.data.schedule;
                        if(this.$detect == 'web') this.changeTime = false;
                        this.sortHistory();
                    }else{
                        this.$message({
                            message: 'Lỗi hệ thống, Vui lòng thử lại',
                            type: 'error',
                            center: true,
                        });
                    }
                })
            }
        }
    },

}
</script>
<style lang="scss">
.auto-up-rv-web {
    .body-card-history {
        overflow-y: auto;
        height: calc(100vh - 160px);
        scrollbar-color: rgba(12, 129, 246, 0.6) white;
        scrollbar-width: thin;
        &::-webkit-scrollbar {
            width: 7px;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(12, 129, 246, 0.6);
            border-radius: 20px;
        }

        &::-webkit-scrollbar-track {
            background: #fff;
            border-radius: 20px;
        }
        .list-history {
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            .stt {
            width: 40px;
            }
            .date-time {
                width: calc( 100% - 30% - 80px );
            }
            .status {
                width: 30%;
            }
            .edit {
                width: 40px;
                .btn-edit {
                    border: none;
                    background: #f1c40f;
                    padding: 2px 9px;
                    border-radius: 5px;
                    i {
                        color: #fff;
                    }
                }
            }
        }
        .history-rv {
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            .stt {
                width: 90px;
            }
            .name {
                width: calc(100% - 130px);
                .text {
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    display: -webkit-box;
                    overflow: hidden;
                }
            }
            .detail {
                width: 40px;
                .btn-detail {
                    border: none;
                    background: #28a745;
                    padding: 2px 9px;
                    border-radius: 5px;
                    i {
                        color: #fff;
                    }
                }
            }
        }
    }
    .load-more {
        height: 40px;
        line-height: 40px;
    }
    .no-history {
        background: rgba(189, 195, 199,0.2);
        .text-no-history {
            color: rgba(0, 0, 0, 0.2);
        }
    }
    .modal-time-pc {
        .title-dialog {
            padding: 10px;
            font-size: 16px !important;
            margin-bottom: 0 !important;
            color: #0c81f6 !important;
            border-bottom: 1px solid #0c81f6;
        }
        .ldc-dialog-content {
            padding: 0 !important;
        }
        .date-change {
            height: 40px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 4px;
            padding: 5px 10px;
            line-height:21px;
            color: #666;
            width: 170px;
            &:focus {
                outline: none !important;
            }
        }
        .time-change {
            input {
                width: 170px;
                height: 40px;
                border-radius: 4px;
                padding: 5px 10px;
                line-height: 31px;
                text-align: left;
            }
        }
        .footer-modal {
            border-top: 1px solid #0c81f6;
            button {
                background: #0c81f6;
                color: #fff;
            }
        }
    }
    .one-history {
        height: calc(100vh - 127px) !important;
    }
}
.auto-up-rv-mobile {
    .popup-history {
        .back-to-list {
            margin-top: 44px;
        }
        .close-dialog {
            display: none !important;
        }
        .close-modal-mobile {
            position: absolute;
            top: 0;
            left: 0;
            .ion-ios-arrow-back {
                color: #fff;
                font-size: 25px;
                line-height: 40px;
                padding: 0 18px;
            }
        }
        .title-dialog {
            background: #0c81f6;
            padding: 10px;
            font-size: 16px !important;
            margin-bottom: 0 !important;
            text-align: center;
            box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
            position: fixed;
            width: 100%;
            top: 0;
        }
        .ldc-dialog-content {
            padding: 0 !important;
            overflow: hidden;
        }
        .body-card-history {
            overflow: auto;
            height: calc(100vh - 88px);
            .list-history {
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                .stt {
                width: 40px;
                }
                .date-time {
                    width: calc( 100% - 30% - 80px );
                }
                .status {
                    width: 30%;
                }
                .edit {
                    width: 40px;
                    .btn-edit {
                        border: none;
                        background: #f1c40f;
                        padding: 2px 9px;
                        border-radius: 5px;
                        i {
                            color: #fff;
                        }
                    }
                }
            }
            .history-rv {
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                .stt {
                    width: 90px;
                }
                .name {
                    width: calc(100% - 130px);
                    .text {
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                        display: -webkit-box;
                        overflow: hidden;
                    }
                }
                .detail {
                    width: 40px;
                    .btn-detail {
                        border: none;
                        background: #28a745;
                        padding: 2px 9px;
                        border-radius: 5px;
                        i {
                            color: #fff;
                        }
                    }
                }
            }
        }
        .load-more {
            height: 40px;
            line-height: 40px;
        }
        .no-history {
            background: rgba(189, 195, 199,0.2);
            .text-no-history {
                color: rgba(0, 0, 0, 0.2);
            }
        }
    }
    .show-list-news {
        .body-card-history {
            height: calc(100vh - 44px ) !important;
            margin-top: 44px;
        }
    }
    .time-ios {
        padding: 10px 30px;
    }
    .time-android {
        padding: 10px 16px;
    }
    .date-change {
        height: 40px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        padding: 5px 10px;
        line-height:21px;
        color: #666;
        width: 170px;
        &:focus {
            outline: none !important;
        }
    }
    .time-change {
        margin-top: 8px;
        .input-time-mobile {
            width: 170px;
            height: 40px;
            border-radius: 4px;
            padding: 5px 10px;
            line-height: 31px;
            text-align: left;
        }
    }
    .time-btn-ios {
        .btn-confirm-ios {
            button {
                width: 100%;
                height: 56px;
                line-height: 41px;
            }
        }
    }
    .time-btn-android {
        .btn-confirm-android {
            border: 1px solid rgba(0, 0, 0, 0.1);
            background: #fff;
            padding: 10px 16px;
            button {
                width: calc( 50% - 10px);
                line-height: 45px;
                padding: 0 !important;
                border-radius: 4px !important;
            }
            .btn-cancel {
                background: #dfe6e9 !important;
            }
            .btn-apply {
                margin-left: 10px;
            }
        }
    }
    .one-history {
        height: calc( 100vh - 44px ) !important;
        margin-top: 44px !important;
    }
}
</style>
